(function () {
  if (window.__elixivaStickyCartLoaded) return;
  window.__elixivaStickyCartLoaded = true;

  var BAR_SELECTOR = '[data-elixiva-sticky-cart]';
  var MAIN_SELECTOR = '#MainContent';
  var refreshTimer = null;

  function escapeAttributeValue(value) {
    return String(value || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function getMain() {
    return document.querySelector(MAIN_SELECTOR);
  }

  function getProductComponent(productId) {
    var main = getMain();
    if (!main) return null;

    var exact = main.querySelector(
      'product-form-component[data-product-id="' + escapeAttributeValue(productId) + '"]'
    );
    return exact || main.querySelector('product-form-component');
  }

  function getProductForm(productId) {
    var component = getProductComponent(productId);
    if (component) {
      return component.querySelector('form[data-type="add-to-cart-form"]') || component.querySelector('form');
    }

    var main = getMain();
    return main ? main.querySelector('form[action*="/cart/add"]') : null;
  }

  function getSourceButton(form) {
    if (!form) return null;
    return (
      form.querySelector('[ref="addToCartButton"]') ||
      form.querySelector('[data-testid="standalone-add-to-cart"]') ||
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]')
    );
  }

  function getQuantityInput(form) {
    return form ? form.querySelector('input[name="quantity"]') : null;
  }

  function parseNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : fallback;
  }

  function getQuantityConfig(form) {
    var input = getQuantityInput(form);
    var min = input ? parseNumber(input.min, 1) : 1;
    var step = input ? parseNumber(input.step, 1) : 1;
    var max = input && input.max !== '' ? parseNumber(input.max, Infinity) : Infinity;
    var value = input ? parseNumber(input.value, min) : min;

    if (!Number.isFinite(min) || min < 1) min = 1;
    if (!Number.isFinite(step) || step <= 0) step = 1;
    if (value < min) value = min;
    if (value > max) value = max;

    return { input: input, min: min, max: max, step: step, value: value };
  }

  function readPriceFromRoot(root, productId) {
    if (!root || !root.querySelector) return '';

    var selector = 'product-price[data-product-id="' + escapeAttributeValue(productId) + '"] [ref="priceContainer"]';
    var container = root.querySelector(selector) || root.querySelector('product-price [ref="priceContainer"]');
    if (!container) return '';

    var sale = container.querySelector('.price__sale:not(.price__hidden) .price');
    var regular = container.querySelector('.price__regular:not(.price__hidden) .price');
    var generic = container.querySelector('.price');
    var node = sale || regular || generic;
    return node ? node.textContent.trim().replace(/\s+/g, ' ') : '';
  }

  function readTitleFromRoot(root) {
    if (!root || !root.querySelector) return '';
    var heading = root.querySelector('main h1, #MainContent h1, h1');
    return heading ? heading.textContent.trim().replace(/\s+/g, ' ') : '';
  }

  function getRadioLabel(radio) {
    if (!radio) return '';
    var label = radio.closest('label');
    if (!label && radio.id) {
      try {
        label = document.querySelector('label[for="' + escapeAttributeValue(radio.id) + '"]');
      } catch (error) {
        label = null;
      }
    }

    var text = label ? label.textContent : radio.dataset.label || radio.value;
    return String(text || '').trim().replace(/\s+/g, ' ');
  }

  function getSellingPlanSource(form) {
    var main = getMain();
    if (!main) return null;

    var selects = Array.from(main.querySelectorAll('select[name="selling_plan"]'));
    var select = selects.find(function (item) {
      return form && form.contains(item);
    }) || selects[0];

    if (select && select.options && select.options.length > 0) {
      return { type: 'select', element: select };
    }

    var radios = Array.from(main.querySelectorAll('input[type="radio"][name="selling_plan"]'));
    if (radios.length > 0) {
      return { type: 'radio', elements: radios };
    }

    return null;
  }

  function syncPlanControl(bar, form) {
    var wrap = bar.querySelector('[data-elixiva-sticky-plan-wrap]');
    var stickySelect = bar.querySelector('[data-elixiva-sticky-plan]');
    if (!wrap || !stickySelect) return;

    var source = getSellingPlanSource(form);
    if (!source) {
      wrap.hidden = true;
      stickySelect.innerHTML = '';
      stickySelect.dataset.sourceType = '';
      return;
    }

    var options = [];
    var selectedValue = '';

    if (source.type === 'select') {
      options = Array.from(source.element.options).map(function (option) {
        return { value: option.value, text: option.textContent.trim(), selected: option.selected };
      });
      selectedValue = source.element.value;
    } else {
      options = source.elements.map(function (radio) {
        return { value: radio.value, text: getRadioLabel(radio), selected: radio.checked };
      });
      var checked = source.elements.find(function (radio) { return radio.checked; });
      selectedValue = checked ? checked.value : '';
    }

    options = options.filter(function (option) {
      return option.text !== '';
    });

    if (options.length < 2) {
      wrap.hidden = true;
      stickySelect.innerHTML = '';
      stickySelect.dataset.sourceType = '';
      return;
    }

    var signature = options.map(function (option) {
      return option.value + '::' + option.text;
    }).join('||');

    if (stickySelect.dataset.signature !== signature) {
      stickySelect.innerHTML = '';
      options.forEach(function (item) {
        var option = document.createElement('option');
        option.value = item.value;
        option.textContent = item.text;
        stickySelect.appendChild(option);
      });
      stickySelect.dataset.signature = signature;
    }

    stickySelect.value = selectedValue;
    stickySelect.dataset.sourceType = source.type;
    wrap.hidden = false;
  }

  function applyPlanSelection(bar, form) {
    var stickySelect = bar.querySelector('[data-elixiva-sticky-plan]');
    var source = getSellingPlanSource(form);
    if (!stickySelect || !source) return;

    var value = stickySelect.value;

    if (source.type === 'select') {
      if (source.element.value !== value) {
        source.element.value = value;
        source.element.dispatchEvent(new Event('input', { bubbles: true }));
        source.element.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    var radio = source.elements.find(function (item) { return item.value === value; });
    if (radio && !radio.checked) radio.click();
  }

  function setBarHeight(bar) {
    if (!bar.classList.contains('is-visible')) return;
    var height = Math.ceil(bar.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--elixiva-sticky-cart-height', height + 'px');
  }

  function setVisible(bar, visible) {
    var changed = bar.classList.contains('is-visible') !== visible;
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    document.body.classList.toggle('elixiva-sticky-cart-visible', visible);

    if (visible) {
      requestAnimationFrame(function () { setBarHeight(bar); });
    } else if (changed) {
      document.documentElement.style.setProperty('--elixiva-sticky-cart-height', '0px');
    }
  }

  function updateVisibility(bar, sourceButton) {
    if (!sourceButton || !sourceButton.isConnected) {
      setVisible(bar, false);
      return;
    }

    var rect = sourceButton.getBoundingClientRect();
    var passedMainButton = rect.bottom < 80;
    setVisible(bar, passedMainButton);
  }

  function setQuantity(bar, form, nextValue) {
    var config = getQuantityConfig(form);
    var value = nextValue;
    if (value < config.min) value = config.min;
    if (value > config.max) value = config.max;

    var output = bar.querySelector('[data-elixiva-sticky-quantity]');
    if (output) output.textContent = String(value);
    bar.dataset.quantity = String(value);

    var minus = bar.querySelector('[data-elixiva-sticky-minus]');
    var plus = bar.querySelector('[data-elixiva-sticky-plus]');
    if (minus) minus.disabled = value <= config.min;
    if (plus) plus.disabled = Number.isFinite(config.max) && value >= config.max;
  }

  function syncQuantityToSource(bar, form) {
    var config = getQuantityConfig(form);
    if (!config.input) return;

    var value = parseNumber(bar.dataset.quantity, config.value);
    if (value < config.min) value = config.min;
    if (value > config.max) value = config.max;

    config.input.value = String(value);
    config.input.dispatchEvent(new Event('input', { bubbles: true }));
    config.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function refreshBar(bar, eventHtml, eventProductId) {
    var productId = eventProductId || bar.dataset.productId;
    if (eventProductId) bar.dataset.productId = String(eventProductId);

    var form = getProductForm(productId);
    var sourceButton = getSourceButton(form);
    var submit = bar.querySelector('[data-elixiva-sticky-submit]');
    var text = bar.querySelector('[data-elixiva-sticky-button-text]');
    var priceMain = bar.querySelector('[data-elixiva-sticky-price]');
    var priceButton = bar.querySelector('[data-elixiva-sticky-button-price]');

    var unavailable = !sourceButton || sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true';
    if (submit) submit.disabled = unavailable;
    if (text) text.textContent = unavailable ? 'Agotado' : 'Añadir al carrito';

    var price = readPriceFromRoot(eventHtml || document, productId) || readPriceFromRoot(document, productId);
    if (price) {
      if (priceMain) priceMain.textContent = price;
      if (priceButton) priceButton.textContent = price;
    }

    if (eventHtml) {
      var nextTitle = readTitleFromRoot(eventHtml);
      var title = bar.querySelector('[data-elixiva-sticky-title]');
      if (nextTitle && title) title.textContent = nextTitle;
    }

    syncPlanControl(bar, form);

    var currentQuantity = parseNumber(bar.dataset.quantity, getQuantityConfig(form).value);
    setQuantity(bar, form, currentQuantity);
    updateVisibility(bar, sourceButton);

    bar._elixivaForm = form;
    bar._elixivaSourceButton = sourceButton;
  }

  function initBar(bar) {
    if (!bar || bar.dataset.elixivaInitialized === 'true') return;
    bar.dataset.elixivaInitialized = 'true';

    document.querySelectorAll(BAR_SELECTOR).forEach(function (other) {
      if (other !== bar && other.dataset.productId === bar.dataset.productId) other.remove();
    });

    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    var form = getProductForm(bar.dataset.productId);
    if (!form) {
      bar.remove();
      return;
    }

    var config = getQuantityConfig(form);
    setQuantity(bar, form, config.value);
    refreshBar(bar);

    var minus = bar.querySelector('[data-elixiva-sticky-minus]');
    var plus = bar.querySelector('[data-elixiva-sticky-plus]');
    var submit = bar.querySelector('[data-elixiva-sticky-submit]');
    var stickyPlan = bar.querySelector('[data-elixiva-sticky-plan]');

    if (minus) {
      minus.addEventListener('click', function () {
        var current = parseNumber(bar.dataset.quantity, 1);
        var cfg = getQuantityConfig(bar._elixivaForm || form);
        setQuantity(bar, bar._elixivaForm || form, current - cfg.step);
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        var current = parseNumber(bar.dataset.quantity, 1);
        var cfg = getQuantityConfig(bar._elixivaForm || form);
        setQuantity(bar, bar._elixivaForm || form, current + cfg.step);
      });
    }

    if (stickyPlan) {
      stickyPlan.addEventListener('change', function () {
        var liveForm = getProductForm(bar.dataset.productId) || bar._elixivaForm || form;
        applyPlanSelection(bar, liveForm);
        window.setTimeout(function () { refreshBar(bar); }, 80);
      });
    }

    if (submit) {
      submit.addEventListener('click', function () {
        var liveForm = getProductForm(bar.dataset.productId) || bar._elixivaForm || form;
        var sourceButton = getSourceButton(liveForm);
        if (!liveForm || !sourceButton || sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true') return;

        syncQuantityToSource(bar, liveForm);
        sourceButton.click();
      });
    }

    var onScroll = function () {
      if (bar._elixivaScrollFrame) return;
      bar._elixivaScrollFrame = requestAnimationFrame(function () {
        bar._elixivaScrollFrame = null;
        var liveButton = getSourceButton(getProductForm(bar.dataset.productId));
        bar._elixivaSourceButton = liveButton;
        updateVisibility(bar, liveButton);
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      onScroll();
      if (bar.classList.contains('is-visible')) setBarHeight(bar);
    }, { passive: true });

    document.addEventListener('variant:update', function (event) {
      var detail = event.detail || {};
      var data = detail.data || {};
      var resource = detail.resource || {};
      var nextProduct = data.newProduct;
      var nextProductId = nextProduct && nextProduct.id ? nextProduct.id : (data.productId || bar.dataset.productId);

      var image = bar.querySelector('[data-elixiva-sticky-image]');
      var preview = resource.featured_media && resource.featured_media.preview_image;
      if (image && preview && preview.src) image.src = preview.src;

      window.setTimeout(function () {
        refreshBar(bar, data.html || null, nextProductId);
      }, 0);
    });

    document.addEventListener('quantity-selector:update', function (event) {
      if (!event.detail || !Number.isFinite(Number(event.detail.quantity))) return;
      var liveForm = getProductForm(bar.dataset.productId);
      setQuantity(bar, liveForm, Number(event.detail.quantity));
    });

    var observedRoot = getProductComponent(bar.dataset.productId) || form;
    if (observedRoot && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        window.clearTimeout(refreshTimer);
        refreshTimer = window.setTimeout(function () {
          refreshBar(bar);
        }, 100);
      });
      observer.observe(observedRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'value', 'checked']
      });
    }

    document.addEventListener('change', function (event) {
      var target = event.target;
      var main = getMain();
      if (!(target instanceof Element) || !main || !main.contains(target)) return;
      if (target.matches('[name="selling_plan"], input[name="quantity"]')) {
        window.setTimeout(function () { refreshBar(bar); }, 30);
      }
    });

    onScroll();
  }

  function boot() {
    var bars = Array.from(document.querySelectorAll(BAR_SELECTOR));
    if (bars.length === 0) return;

    var currentProductId = '';
    var main = getMain();
    var component = main && main.querySelector('product-form-component[data-product-id]');
    if (component) currentProductId = component.dataset.productId || '';

    var bar = bars.find(function (item) {
      return currentProductId && item.dataset.productId === currentProductId;
    }) || bars[0];

    bars.forEach(function (item) {
      if (item !== bar) item.remove();
    });

    initBar(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
